export default "__VITE_ASSET__BWx$qk_u__"